import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';

import Button from 'shared/components/widgets/button';

import fileUploadLottie from '@assets/lottie/fileUpload.json';
import { FC } from 'react';

const FileUploadLottie = () => (
  <Box width="160px" height="160px">
    <Lottie animationData={fileUploadLottie} loop={true} />
  </Box>
);

type FileUploadingDialogContentProps = {
  progress?: number;
  closeAction: () => void;
  stopAction?: () => void;
};

const FileUploadingDialogContent: FC<FileUploadingDialogContentProps> = ({
  progress,
  closeAction,
  stopAction,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={4} padding="30px 52px">
      <Box display="flex" justifyContent="center">
        <FileUploadLottie />
      </Box>
      <Box display="flex" flexDirection="column" gap={4}>
        <Typography
          fontSize="17px"
          lineHeight="22px"
          fontWeight={400}
          color="var(--gray-800)"
          align="center"
        >
          선택한 파일을 업로드 중입니다.
        </Typography>
        <Box display="flex" flexDirection="row" justifyContent="center">
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="10px"
          >
            <Typography
              fontSize="13px"
              lineHeight="20px"
              fontWeight={500}
              color="var(--neutral-800)"
            >
              {progress} / 100
            </Typography>
            <Button
              variant="text"
              onClick={() => {
                closeAction();
                if (stopAction) stopAction();
              }}
            >
              중지하기
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FileUploadingDialogContent;
